export class Questionaire {
    static readonly audience = 0;
    static readonly question1 = 1;
    static readonly question2 = 2;
};